import React from 'react';
import classNames from 'classnames/bind';
import styles from './quoteCard.module.scss';

interface ICompetencyTypeDescriptionProps {
  quote: string;
  author: string;
}

const cx = classNames.bind(styles);

const QuoteCard = ({ quote, author }: ICompetencyTypeDescriptionProps) => {
  return (
    <div className={cx('cardWrap')}>
      <div className={cx('card')}>
        <p className={cx('desc')}>{quote}</p>
        <span className={cx('author')}>{author}</span>
      </div>
    </div>
  );
};

export default QuoteCard;
